import { Fragment } from "react";
import type { HeroText } from "../grip";

/**
 * An order from `grip.ts`, drawn: the accented runs in the hand's colour, a
 * line break wherever a run asks for one.
 *
 * Each line is kept whole (`nowrap`) and the break is a real `<br />`, so
 * « Auriculaire sur Si, » and « 3ème octave » are the two lines on every
 * width the panel has, instead of whatever the browser found room for.
 */
export function HeroRuns({
  hero,
  accentColor,
}: {
  readonly hero: HeroText;
  readonly accentColor: string;
}) {
  const lines: HeroText[] = [[]];

  for (const part of hero) {
    lines[lines.length - 1] = [...lines[lines.length - 1], part];

    if (part.breakAfter === true) {
      lines.push([]);
    }
  }

  return (
    <>
      {lines.map((line, i) => (
        <Fragment key={i}>
          {i > 0 && <br />}
          <span style={{ whiteSpace: lines.length > 1 ? "nowrap" : undefined }}>
            {line.map((part, j) =>
              part.accent ? (
                <span key={j} style={{ color: accentColor }}>
                  {part.text}
                </span>
              ) : (
                <Fragment key={j}>{part.text}</Fragment>
              ),
            )}
          </span>
        </Fragment>
      ))}
    </>
  );
}
